export interface User {
  id: string;
  username: string;
  name: string;
  email: string;
  birthdate: string;
  profilePicture?: string;
}

export interface Friend {
  id: string;
  userId: string;
  friendId: string;
  status: "pending" | "accepted" | "rejected";
  createdAt: string;
}

export enum PrivacyLevel {
  PRIVATE = "private",
  FRIENDS = "friends",
  PUBLIC = "public"
}

export interface TemplateTimeline {
  id: string;
  name: string;
  name_en: string;
  description?: string;
  description_en?: string;
  is_default: boolean;
  created_at: string;
  updated_at: string;
}

export interface TemplateTimelineSection {
  id: string;
  template_timeline_id: string;
  name: string;
  name_en: string;
  slug: string;
  age_from: number;
  age_to: number;
  description: string;
  description_en?: string;
  cosmic_aspect?: string;
  cosmic_aspect_en?: string;
  icon: string;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export interface ProfileTimeline {
  id: string;
  user_id: string;
  template_timeline_id: string;
  created_at: string;
  updated_at: string;
}

export interface ProfileTimelineSection {
  id: string;
  profile_timeline_id: string;
  template_timeline_section_id: string;
  name?: string;
  name_en?: string;
  description?: string;
  description_en?: string;
  cosmic_aspect?: string;
  cosmic_aspect_en?: string;
  icon?: string;
  is_active: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
  // Computed fields from template when null values
  effective_name?: string;
  effective_name_en?: string;
  effective_description?: string;
  effective_description_en?: string;
  effective_cosmic_aspect?: string;
  effective_cosmic_aspect_en?: string;
  effective_icon?: string;
  // Template section data for reference
  template_section?: TemplateTimelineSection;
  // Age ranges computed from birthdate
  yearFrom?: number;
  yearTo?: number;
  isExpanded?: boolean;
}

// Keeping this for backward compatibility with existing components
export interface TimelineSection {
  id: string;
  name: string;
  name_en: string;
  slug: string;
  age_from: number;
  age_to: number;
  description: string;
  description_en?: string;
  cosmic_aspect_en?: string;
  icon: string;
  cosmic_aspect?: string;
  created_at: string;
  updated_at: string;
  yearFrom?: number;
  yearTo?: number;
  isExpanded?: boolean;
}

export interface TimelineEntry {
  id: string;
  user_id: string;
  profile_timeline_section_id: string;
  creator_id: string;
  title: string;
  content?: string;
  date: string;
  year: number;
  month: number;
  day?: number;
  photos?: string[];
  privacy_level: PrivacyLevel;
  is_approved: boolean;
  created_at: string;
  updated_at: string;
}

export interface Notification {
  id: string;
  userId: string;
  type: "new_entry" | "friend_request" | "entry_approved";
  entryId?: string;
  friendRequestId?: string;
  isRead: boolean;
  createdAt: string;
}
